import { Card, Stack, Text, Title } from '@mantine/core';
import { MessageDescriptor, useIntl } from 'react-intl';

import styles from '../../../InitialSetupModal.module.scss';

type Props = {
    label: MessageDescriptor;
    rows: Array<{
        key: string;
        label: string;
        value: string;
    }>;
};

const SummaryTile = ({
    label,
    rows,
}: Props) => {
    const intl = useIntl();

    return (
        <Card className={styles.summaryTile} shadow="sm" padding="lg" radius="md" withBorder>
            <Title order={4} size="h5" mb="sm">
                {intl.formatMessage(label)}
            </Title>
            <Stack gap="xs">
                {rows.map((row) => (
                    <div key={row.key} className={styles.summaryRow}>
                        <Text size="sm" className={styles.summaryRowLabel}>{row.label}</Text>
                        <Text size="sm" className={styles.summaryRowValue}>{row.value}</Text>
                    </div>
                ))}
            </Stack>
        </Card>
    );
};

export default SummaryTile;
